module.exports = __webpack_public_path__ + "media/images/phone-dashboard-2353fbc28dee99b7554853bc18b75613.png";